import { useState } from 'react';
import { apiBaseUrl } from 'src/config';

function useApi() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isLinked, setIsLinked] = useState(false);

    const checkAddressLink = async (address) => {
        setLoading(true);
        setError(null);
        setIsLinked(false);
        try {
            const response = await fetch(`${apiBaseUrl}users/check_address?address=${address}`);
            if (response.status === 200) {
                setIsLinked(true);
            } else if (response.status === 404) {
                setIsLinked(false);
            } else {
                throw new Error('An error has occurred.');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const submitSignature = async (code, addressStr, signature) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${apiBaseUrl}users/signature`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ code, addressStr, signature }),
            });

            if (!response.ok) {
                throw new Error('The entered code is incorrect');
            }
            const result = await response.json();
            setData(result);
            setIsLinked(true);
            return true;
        } catch (err) {
            setError(err.message);
            //setIsLinked(true);
            return false;
        } finally {
            setLoading(false);
        }
    };

    return { data, loading, error, isLinked, checkAddressLink, submitSignature };
}

export default useApi;
